import * as actions from './actions';

const initialState = {
  memberships: [],
  loading: false,
  checkoutLoading: false,
  error: null,
};

export default function publicStoreReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_STORE_REQUEST:
      return { ...state, loading: true, error: null };
    case actions.FETCH_STORE_SUCCESS:
      return { ...state, loading: false, memberships: action.payload };
    case actions.FETCH_STORE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case actions.CHECKOUT_ONETIME_REQUEST:
      return { ...state, checkoutLoading: true, error: null };
    case actions.CHECKOUT_ONETIME_SUCCESS:
      return { ...state, checkoutLoading: false };
    case actions.CHECKOUT_ONETIME_FAILURE:
      return { ...state, checkoutLoading: false, error: action.payload };

    default:
      return state;
  }
}
